import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 33"
    {...props}
  >
    <path
      fill="currentColor"
      d="m26.707 6.804-6.293 6.292H24a1 1 0 0 1 0 2h-6a1 1 0 0 1-1-1v-6a1 1 0 0 1 2 0v3.586l6.292-6.293a1 1 0 0 1 1.415 1.415M14 17.096H8a1 1 0 0 0 0 2h3.586l-6.294 6.293a1 1 0 0 0 1.415 1.415L13 20.51v3.586a1 1 0 0 0 2 0v-6a1 1 0 0 0-1-1"
    />
  </svg>
);
const SvgIconArrowInSimple = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconArrowInSimple);
export default Memo;
